import { useEffect } from 'react';

const SITE_NAME = 'Doritostats';
const SITE_URL = 'https://doritostats.up.railway.app';
const DEFAULT_OG_IMAGE = `${SITE_URL}/og-image.png`;

/**
 * Sets document <title>, <meta description>, canonical <link>, and Open Graph
 * tags for the current page. Pass only the fields you want to override;
 * omitting a field leaves the existing value unchanged.
 *
 * @param {{
 *   title?: string,
 *   description?: string,
 *   canonical?: string,
 *   ogImage?: string,
 * }} options
 */
const usePageMeta = ({ title, description, canonical, ogImage } = {}) => {
  useEffect(() => {
    const pageTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
    const pageDescription = description || 'Advanced fantasy football analytics for ESPN leagues — luck index, playoff simulations, weekly awards, all-time records, and more.';
    const pageUrl = canonical ? `${SITE_URL}${canonical}` : SITE_URL;
    const pageImage = ogImage || DEFAULT_OG_IMAGE;

    // document title
    document.title = pageTitle;

    setMeta('name', 'description', pageDescription);

    // Canonical
    let canonicalEl = document.querySelector('link[rel="canonical"]');
    if (!canonicalEl) {
      canonicalEl = document.createElement('link');
      canonicalEl.rel = 'canonical';
      document.head.appendChild(canonicalEl);
    }
    canonicalEl.href = pageUrl;

    // Open Graph
    setMeta('property', 'og:title', pageTitle);
    setMeta('property', 'og:description', pageDescription);
    setMeta('property', 'og:url', pageUrl);
    setMeta('property', 'og:image', pageImage);

    // Twitter Card
    setMeta('name', 'twitter:title', pageTitle);
    setMeta('name', 'twitter:description', pageDescription);
    setMeta('name', 'twitter:image', pageImage);
  }, [title, description, canonical, ogImage]);
};

function setMeta(attrName, attrValue, content) {
  let el = document.querySelector(`meta[${attrName}="${attrValue}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attrName, attrValue);
    document.head.appendChild(el);
  }
  el.content = content;
}

export default usePageMeta;
